/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolPetsIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-pets"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M4.35 12.43Q3.15 12.43 2.33 11.6Q1.5 10.78 1.5 9.57Q1.5 8.38 2.33 7.55Q3.15 6.72 4.35 6.72Q5.55 6.72 6.38 7.55Q7.2 8.38 7.2 9.57Q7.2 10.78 6.38 11.6Q5.55 12.43 4.35 12.43ZM8.95 8.38Q8.95 8.38 8.35 8.38Q7.75 8.38 6.92 7.55Q6.1 6.72 6.1 5.53Q6.1 4.33 6.92 3.5Q7.75 2.67 8.95 2.67Q10.15 2.67 10.97 3.5Q11.8 4.33 11.8 5.53Q11.8 6.72 10.97 7.55Q10.15 8.38 8.95 8.38ZM15.05 8.38Q15.05 8.38 14.45 8.38Q13.85 8.38 13.03 7.55Q12.2 6.72 12.2 5.53Q12.2 4.33 13.03 3.5Q13.85 2.67 15.05 2.67Q16.25 2.67 17.07 3.5Q17.9 4.33 17.9 5.53Q17.9 6.72 17.07 7.55Q16.25 8.38 15.05 8.38ZM19.65 12.43Q18.45 12.43 17.63 11.6Q16.8 10.78 16.8 9.57Q16.8 8.38 17.63 7.55Q18.45 6.72 19.65 6.72Q20.85 6.72 21.68 7.55Q22.5 8.38 22.5 9.57Q22.5 10.78 21.68 11.6Q20.85 12.43 19.65 12.43ZM6.55 22.63Q5.28 22.63 4.41 21.66Q3.55 20.7 3.55 19.38Q3.55 18 4.49 16.96Q5.42 15.93 6.3 14.88Q6.97 14.05 7.56 13.15Q8.15 12.25 8.85 11.43Q9.45 10.7 10.25 10.24Q11.05 9.78 12 9.78Q12.95 9.78 13.75 10.24Q14.55 10.7 15.15 11.43Q15.82 12.25 16.4 13.16Q16.98 14.07 17.7 14.88Q18.65 15.9 19.55 16.95Q20.45 18 20.45 19.38Q20.45 20.7 19.59 21.66Q18.73 22.63 17.45 22.63Q16.07 22.63 14.72 22.4Q13.38 22.18 12 22.18Q10.63 22.18 9.28 22.4Q7.92 22.63 6.55 22.63Z" fill={color} />
    </svg>
  );
}
